import React from 'react';
import { useSelector } from 'react-redux'
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import Sidebar from '../componets/Sidebar';

import DashboardHeader from '../componets/DashboardHeader';
const DashboardLayout = () => {
  const isAuthenticated = localStorage.getItem("token");
  const { isTheme } = useSelector((state) => state.currentStage)
  const location = useLocation();
  const isGraphDashboard = location.pathname === '/graph-dashboard';
  console.log("location", location)
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className={isTheme === 'light' ? 'maindashboard-light' : isGraphDashboard ? " " : 'maindashboard-container'}>
      <DashboardHeader />
       {/* {!isGraphDashboard && <DashboardHeader />} */}
      <div className='d-flex dashboard-center'>
        {/* <Sidebar /> */}
         {!isGraphDashboard && <Sidebar />}
        <div className='w-100 dashboard-layout'>
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default DashboardLayout